// Utilitaires pour localStorage
export const storageUtils = {
  get: <T>(key: string, defaultValue: T): T => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : defaultValue
    } catch {
      return defaultValue
    }
  },

  set: <T>(key: string, value: T): void => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.error('Error saving to localStorage:', error)
    }
  },

  remove: (key: string): void => {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from localStorage:', error)
    }
  }
}

// Utilitaires pour les paramètres URL
export const urlUtils = {
  getQueryParam: (param: string): string | null => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(param)
  },

  buildRedirectUrl: (baseUrl: string, params: Record<string, string>): string => {
    const url = new URL(baseUrl)
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.set(key, value)
    })
    return url.toString()
  },

  buildPasswordResetUrlPrefix: (clientId: string): string => {
    const params = new URLSearchParams({ client_id: clientId })
    return `${window.location.origin}/reset-password?${params.toString()}&token=`
  },
}

// Utilitaires pour la validation
export interface PasswordCriteria {
  minLength: boolean
  hasUppercase: boolean
  hasLowercase: boolean
  hasDigit: boolean
  hasSpecialChar: boolean
}

export const validationUtils = {
  isValidEmail: (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  },

  getPasswordCriteria: (password: string): PasswordCriteria => ({
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasDigit: /\d/.test(password),
    hasSpecialChar: /[^A-Za-z0-9]/.test(password),
  }),

  isValidPassword: (password: string): boolean => {
    const criteria = validationUtils.getPasswordCriteria(password)
    return (
      criteria.minLength &&
      criteria.hasUppercase &&
      criteria.hasLowercase &&
      criteria.hasDigit &&
      criteria.hasSpecialChar
    )
  },

  passwordsMatch: (password: string, confirmPassword: string): boolean => {
    return password === confirmPassword
  }
}
